import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';
import { isTaskOnTime } from '../../data/supabaseApi';
import './Charts.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const MemberPerformanceChart = ({ tasks, users = [] }) => {
  const members = users.length
    ? users.filter(u => u.role === 'member').map(u => u.name)
    : [...new Set(tasks.map(t => t.assignedMember || t.userName).filter(Boolean))].sort();
  const memberStats = {};
  members.forEach(m => {
    memberStats[m] = { onTime: 0, delayed: 0, inProgress: 0 };
  });
  tasks.forEach(task => {
    const name = task.assignedMember || task.userName;
    if (!memberStats[name]) memberStats[name] = { onTime: 0, delayed: 0, inProgress: 0 };
    const s = task.currentStatus || task.status;
    if (s === 'Completed') {
      if (isTaskOnTime(task) === true) memberStats[name].onTime++;
      else memberStats[name].delayed++;
    } else if (s === 'Delayed') memberStats[name].delayed++;
    else memberStats[name].inProgress++;
  });

  const labels = members;
  const onTimeData = labels.map(m => memberStats[m].onTime);
  const delayedData = labels.map(m => memberStats[m].delayed);
  const inProgressData = labels.map(m => memberStats[m].inProgress);

  const hasData = [...onTimeData, ...delayedData, ...inProgressData].some(v => v > 0);
  if (!hasData) {
    return (
      <div className="chart-container">
        <div className="chart-empty-state"><p>No data</p></div>
      </div>
    );
  }

  const chartData = {
    labels,
    datasets: [
      { label: 'On time', data: onTimeData, backgroundColor: 'rgba(34, 197, 94, 0.8)', borderRadius: 4 },
      { label: 'Delayed', data: delayedData, backgroundColor: 'rgba(239, 68, 68, 0.8)', borderRadius: 4 },
      { label: 'In progress', data: inProgressData, backgroundColor: 'rgba(148, 163, 184, 0.8)', borderRadius: 4 }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { padding: 12, usePointStyle: true } },
      tooltip: { mode: 'index' }
    },
    scales: {
      y: { beginAtZero: true, stacked: true, grid: { color: 'rgba(0,0,0,0.06)' } },
      x: { stacked: true, grid: { display: false } }
    }
  };

  return (
    <div className="chart-container">
      <h4 className="chart-title">Member performance</h4>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default MemberPerformanceChart;
